"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M10.261 14.445a3.004 3.004 0 0 0 4.184-4.184l-4.184 4.184a230.37 230.37 0 0 0-1.089-.324l7.564-7.564a.516.516 0 0 1 .025-.026l3.385-3.384a.5.5 0 0 1 .707.707l-2.924 2.923c3.42 1.942 5.845 4.773 5.952 4.9a.5.5 0 0 1 .001.646C23.651 12.596 18.161 19 12 19c-1.72 0-3.447-.387-5.14-1.154l-3.007 3.008a.498.498 0 0 1-.707 0 .5.5 0 0 1 0-.707l6.024-6.025 1.091.323ZM4.953 16.72a.491.491 0 0 1-.276-.084C1.812 14.732.159 12.385.09 12.285a.5.5 0 0 1 .028-.608C.349 11.404 5.839 5 12 5c1.039 0 2.143.193 3.281.576a.5.5 0 0 1 .314.633.493.493 0 0 1-.633.314C13.928 6.176 12.931 6 12 6c-4.981 0-9.703 4.777-10.854 6.027a18.286 18.286 0 0 0 4.083 3.775c.23.152.293.463.14.692a.495.495 0 0 1-.416.225Zm3.608-3.61a.5.5 0 0 1-.491-.412A3.912 3.912 0 0 1 8 12c0-2.206 1.794-4 4-4 .238 0 .47.029.697.069a.5.5 0 0 1-.174.984A2.99 2.99 0 0 0 12 9c-1.654 0-3 1.346-3 3 0 .18.023.353.054.523a.5.5 0 0 1-.493.587Zm6.6-3.563A4.004 4.004 0 0 1 12 16a3.966 3.966 0 0 1-2.454-.84L7.62 17.087c1.45.607 2.92.914 4.38.914 4.945 0 9.636-4.71 10.828-6-.755-.817-2.91-2.998-5.634-4.487L15.16 9.546Z",
    clipRule: "evenodd"
  })]
});